import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { StartComponent }                     from './start.component';
import { CacheLoadCanActivateGuard }              from './cache-load-can-activate.guard';

import { InitializationComponent } from "./initialization.component";


@NgModule({
    imports: [
        RouterModule.forRoot([{
            path: '',
            component: InitializationComponent,
            canActivate: [CacheLoadCanActivateGuard],
            children:
            [
                {
                    path: '',
                    component: StartComponent
                }
            ]
        }])
    ],
    providers: [ CacheLoadCanActivateGuard],
    exports:[ RouterModule ]
})

export class InitializationRoutingModule {}
